import React from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

interface EditorProps {
  editText: string;
  setEditText: (editText: string) => void;
}

const Editor = ({ editText, setEditText }: EditorProps) => {
  const sortedFontOptions = [
    // 'Arial',
    // 'Comic Sans MS',
    // 'Courier New',
    '맑은고딕', // 한글 폰트 추가
    '고운 돋음',
    '고운 바탕',
    'G마켓 산스',
    '청주김생체',
    '여기어때 잘난체',
  ].sort();

  return (
    <SunEditor
      setContents={editText}
      onChange={setEditText}
      setOptions={{
        buttonList: [
          ['undo', 'redo'],
          ['font', 'fontSize'],
          // ['paragraphStyle', 'blockquote'],
          ['bold', 'underline', 'italic', 'strike' /*'subscript', 'superscript'*/],
          ['fontColor', 'hiliteColor'],
          ['align' /*'list', 'lineHeight'*/],
          ['outdent', 'indent'],
          ['table', 'horizontalRule', /*'link',*/ 'image' /*'video'*/],
          ['removeFormat'],
        ], // Or Array of button list, eg. [['font', 'align'], ['image']]
        defaultTag: 'div',
        minHeight: '300px',
        maxHeight: '60vh',
        showPathLabel: false,
        font: sortedFontOptions,
      }}
    />
  );
};
export default Editor;
